export const POLL_MS = 3 * 60 * 1000;

// Hidden notification docks at the right edge and slides out to ask for attention.
export const DOCK_PEEK_EVERY_MS = 45 * 1000;
export const DOCK_PEEK_MS = 4 * 1000;
export const DOCK_FIRST_PEEK_DELAY_MS = 1500;

// Logins that never raise or verify partner invoices.
export const HIDDEN_ROLES = new Set([
  "partner",
  "engineer",
  "client_user",
  "client_manager",
  "client_admin",
  "payable_partner_user",
]);

export const TYPE_FILTERS = [
  { key: "all", label: "All", types: null },
  { key: "requests", label: "Invoice requests", types: ["invoice_request"] },
  {
    key: "invoices",
    label: "Partner invoices",
    types: ["partner_invoice", "expense_invoice", "prepayment_invoice"],
  },
];

export const hiddenStorageKey = () =>
  `kyc-notice-hidden:${localStorage.getItem("user_uuid") || "me"}`;
